module.exports = __webpack_public_path__ + "media/images/lb/437-3f2cbc37c506a151ba21f36cd382e231.svg";